import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pin-board',
  templateUrl: './pin-board.component.html',
  styleUrls: ['./pin-board.component.css']
})
export class PinBoardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
